import { render, staticRenderFns } from "./cModalRoles.vue?vue&type=template&id=690be75a"
import script from "./cModalRoles.vue?vue&type=script&lang=js"
export * from "./cModalRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports